export type SchoolCafeteria = {
  "@context": string;
  "@id": string;
  "@type": string;
  id: number;
  city: string;
  postalCode: string;
  streetAddress: string;
};
